/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { FileInvalidEvent, InvalidFileReason, NotificationService } from '@gh/core-ui';
import { ComponentOrItem } from '../../resources/component-and-item-details.model';
import { ComponentOrItemFormState } from '../component-or-item-form-state';

@Component({
  selector: 'gh-component-or-item-details-picture-tab',
  template: require('./component-or-item-details-picture-tab.component.html'),
})
export class ComponentOrItemDetailsPictureTabComponent {
  constructor(public form: ComponentOrItemFormState<ComponentOrItem>,
              private notificationService: NotificationService) {
  }

  onFileInvalid(event: FileInvalidEvent): void {
    // @ts-ignore
    this.notificationService.error({
      [InvalidFileReason.TooLarge]: 'msg_item_picture_not_correct',
      [InvalidFileReason.NotAccepted]: 'msg_item_picture_not_accepted',
    }[event.reason]);
  }
}
